import { inject, Injectable } from '@angular/core';
import { FirebaseAuthErrorMap } from '@auth/classes/firebase-errors';
import { ToastTypes } from '@shared/models/toast';
import { ToastService } from '@shared/services/toast/toast.service';

@Injectable({
	providedIn: 'root',
})
export class AuthToastService {
	private toastService = inject(ToastService);

	handleError(title: string, errorCode: string, messageOverride?: string): void {
		const message = FirebaseAuthErrorMap[errorCode] || 'An error occurred. Please try again later.';
		this.toastService.showToast({
			title: title,
			message: messageOverride ?? message,
			type: ToastTypes.ERROR,
		});
	}
}
